<div class="pronexo-modal">
  <div class="header">
    <h3>Usuarios Pronexo</h3>
  </div>

  <div class="body">
    <div class="filters">
      <input type="text" class="form-control" placeholder="Buscar..." (keyup)="changeSearch($event)"/>
        <!-- <input type="text" class="form-control" placeholder="Buscar..." (keyup)="changeSearch($event)" (change)="changeWorkerSearch($event.target.value)"
        placeholder="12.345.678-9" formatRut /> -->
      <!-- <button type="button" class="btn search-btn shadow-none" (click)="searchWorker()">Buscar por Rut</button>
      <button type="button" class="btn clean-btn shadow-none" (click)="cleanSearch()">Limpiar</button> -->
    </div>

    <table class="table table-striped table-responsive">
      <thead>
        <th>Asignar</th>
        <th *ngFor="let column of columns">
          {{column}}
        </th>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows" [id]="row.id">
          <td>
            <span [class]="isIconActive('add', row.id) ? 'active' : 'disabled'" (click)="addWorker(row.worker)"
              [ngbTooltip]="'Asignar'">
              <img [src]="isIconActive('add', row.id) ? 'assets/icons/add.svg' : 'assets/icons/add_disabled.svg'" />
            </span>
            <span [class]="isIconActive('minus', row.id) ? 'active' : 'disabled'" (click)="removeWorker(row.worker)"
              [ngbTooltip]="'Desasignar'">
              <img
                [src]="isIconActive('minus', row.id) ? 'assets/icons/minus.svg' : 'assets/icons/minus_disabled.svg'" />
            </span>
          </td>
          <ng-container *ngFor="let cell of row.cells">
            <span *ngIf="cell.tooltip">
              <td [class]="cell.class" [ngbTooltip]="cell.content" placement="left">
                {{cell.content}}
              </td>
            </span>
            <td *ngIf="!cell.tooltip" [class]="cell.class">
              {{cell.content}}
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>

    <div class="d-flex justify-content-between p-2 pagination">
      <ngb-pagination [collectionSize]="totalAmmount" [page]="page + 1" (pageChange)="onChangePage($event - 1)"
        [pageSize]="pageSize" [maxSize]="1" [rotate]="true" [boundaryLinks]="true"></ngb-pagination>

      <div *ngIf="loading" class="spinner-border spinner" role="status">
        <span class="sr-only">Loading...</span>
      </div>

      <select class="custom-select" style="width: auto" name="pageSize" (change)="onChangeSize($event.target.value)">
        <option *ngFor="let option of sizeOptions" [value]="option.value">{{option.label}}</option>
      </select>
    </div>

    <label>{{workersIdSelected.length.toString() + ' trabajadores seleccionados'}}</label>
  </div>

  <div class="footer">
    <button type="button" class="btn cancel-btn" (click)="modal.dismiss('Cancel')">Cancelar</button>
    <button type="button" class="btn accept-btn" (click)="onAccept()">Confirmar</button>
  </div>
</div>
